<template>
	<header-block :title="goal ? goal.name + ' Goal': 'Savings Goal'"></header-block>
	<CustomerLoadWait :customer="goal" />
	<transition>
		<div v-if="goal && goal.account">
			<GoalInfoPanel v-if="goal" class="edged goalInfoPanel" :goal="goal.targetAmount" :saved="goal.currentBalance" :instalment="goal.instalmentAmount" :formatter="formatter" />
			<div class="info">
				<WellPanel :data="wellData"/>
				<MGButton icon="mdi-delete" text="Delete Goal" @click="showDelete = true" />
			</div>
		</div>
	</transition>

    <!-- Delete Confirmation Dialog -->
    <MGDialog v-model="showDelete" max-width="400" content-height="150px" title="Delete Goal">
      <template #content>
        <p>Are you sure you want to delete your {{goal.name}} goal?</p>
      </template>
      <template #actions>
        <MGButton :fullWidth="true" @click="deleteGoal" text="Delete" />
        <MGButton :stacked="true" :fullWidth="true" @click="showDelete = false" :outline="true" text="Cancel" />
      </template>
    </MGDialog>

</template>

<script>

import Services from '../mixins/Services';
//import BarArrowButton from './elements/BarArrowButton.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
// import DrawerPanel from './elements/DrawerPanel.vue';
import GoalInfoPanel from './elements/GoalInfoPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import WellPanel from './elements/WellPanel.vue';
// import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
import MGDialog from './elements/MGDialog.vue';

export default {
	mixins: [Services],
	components: {CustomerLoadWait, HeaderBlock, GoalInfoPanel, WellPanel, MGButton, MGDialog},
	data() {
		return {
			goal:null,
			wellData: null,
			showDelete: false
		}
	},
	methods: {
		deleteGoal() {
			this._deleteSavingGoal(this.goal.id, () => {
				this._clearSavingGoals();
				this.$router.push('/Goals');
			});
		},
		onLoad: async function() {
			this._getCustomer(() => {
				this._getBankingInfo(() => {
					this._getSavingGoal(this.$route.params.id, (g) => {
						this.goal = g;
						this.goal.account = this.bankInfo.accounts.find(a => a.id == g.bankAccountID);
						this.wellData = [
							{order: 0, label: 'Goal', value: this.goal.name},
							{order: 1, label: 'Account', value: this.goal.account.bank.prettyName + ' ' + this.goal.account.displayName},
							{order: 2, label: 'Account Balance', value: this.formatter.format(this.goal.account.balance)},
							{order: 3, label: 'Saved so Far', value: this.formatter.format(this.goal.currentBalance)},
							//{order: 4, label: 'Unallocated', value: this.formatter.format(this.goal.account.balance - this.goal.currentBalance)},
							{order: 5, label: 'Goal Target', value: this.formatter.format(this.goal.targetAmount)},
							{order: 6, label: 'Monthly Instalment', value: this.formatter.format(this.goal.instalmentAmount)},
						];
					});
				});
			});
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>


</style>
